import { MenuHeaderTitleComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title.component';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { ProductMenu } from '../product-menu';
import { Type } from '@angular/core';
import { SectionType } from '../../enum/dto/section-type.enum';
import { Section } from '../section/section';
import { MenuSectionHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section-header/menu-section-header.component';
import { SectionColumnProductInfoType } from '../../enum/shared/section-column-product-info-type';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import { ColWidth } from '../../shared/col-width';
import { SectionColumnViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/SectionColumnViewModel';
import type { SectionWithProducts } from '../section/section-with-products';
import { EmptyMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/empty-menu-footer/empty-menu-footer.component';
import { ProductMenuFooterComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-footer/product-menu-footer.component';
import { ExpandedProductSectionHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section-header/expanded-product-section-header/expanded-product-section-header.component';
import { EmptySection } from '../section/empty-section';
import { EmptySectionMatchesColorOfFollowingProductSection } from '../section/empty-section-matches-color-of-following-product-section';

export class KillerQueenMenu extends ProductMenu {
  protected override deserializeSections() {
    this.sections?.forEach(section => {
      const isProductSection = section?.sectionType === SectionType.Product;
      if (isProductSection) section.sectionType = SectionType.KillerQueenProduct;
    });
    this.sections = window?.injector?.Deserialize?.arrayOf(Section, this.sections) ?? [];
  }

  protected override deserializeTemplateSections() {
    this.templateSections?.forEach(templateSection => {
      const isProductSection = templateSection?.sectionType === SectionType.Product;
      if (isProductSection) templateSection.sectionType = SectionType.KillerQueenProduct;
    });
    this.templateSections = window?.injector?.Deserialize?.arrayOf(Section, this.templateSections) ?? [];
  }

  getThemeClass(): string {
    return 'killer-queen';
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Oswald.Medium_500, FONT.Poppins.SemiBold_600];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/kos4wps.css';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleComponent;
  }

  getSectionsHeaderType(): Type<MenuSectionHeaderComponent> {
    return ExpandedProductSectionHeaderComponent;
  }

  getFooterType(): Type<ProductMenuFooterComponent> {
    return EmptyMenuFooterComponent;
  }

  getShowFooter(): boolean {
    return false;
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  getShowClassificationsInAssetColumn(): boolean {
    return true;
  }

  primaryPriceColumnAlsoShowOriginalPriceIfOnSale(section: SectionWithProducts): boolean {
    return true;
  }

  getThemeSpecifiedColumnViewModels(
    sectionRowViewModels: SectionRowViewModel[],
    rowViewModel: SectionRowViewModel,
    widths: ColWidth[] = this.getColWidths(rowViewModel)
  ): SectionColumnViewModel[] {
    const colVMs = [];
    const layoutType = rowViewModel?.getLayoutType();
    const productTitle = new SectionColumnViewModel(layoutType, null);
    productTitle.columnType = SectionColumnProductInfoType.ProductTitle;
    const asset = new SectionColumnViewModel(layoutType, null);
    asset.columnType = SectionColumnProductInfoType.Asset;
    const price = new SectionColumnViewModel(layoutType, null);
    price.columnType = SectionColumnProductInfoType.VariantPrice;
    colVMs.push(productTitle, asset, price);
    return colVMs;
  }

  showTerpenes(): boolean {
    return false;
  }

  getEmptySectionType(): Type<EmptySection> {
    return EmptySectionMatchesColorOfFollowingProductSection;
  }
}
